import React, {useContext, useMemo, useState} from 'react';
import DatePicker from "react-datepicker";
import { de } from 'date-fns/locale';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import {Accordion, AccordionDetails, AccordionSummary, Snackbar} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {axios} from '../../axios';
import {LangContext} from '../../App';
import {getTranslation} from '../../translations';
import {checkDateAvailability, processAvailableDates} from '../../utils/dateAvailability';


const Callback = ({title, tourType, tourId, tourPrice, tourData}) => {
    const lang = useContext(LangContext);
    const t = (key) => getTranslation(lang, key);

    const [data,setData] = useState({
        firstName:'',
        secondName:'',
        email:'',
        message:'',
        phone:'',
        date: null,
        guests: 1
    })
    const availableDateRanges = useMemo(
        () => (tourData?.available_dates ? processAvailableDates(tourData.available_dates) : []),
        [tourData]
    );

    const [startDate, setStartDate] = useState(null);
    const [phone, setPhone] = useState('');
    const [popUp, setPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleDateChange = (date) => {
        setStartDate(date);
        setData({...data, date: date});
    };

    const handleInputChange = (field, value) => {
        setData({...data, [field]: value});
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');

        try {
            const payload = {
                name: `${data.firstName} ${data.secondName}`.trim(),
                email: data.email,
                phone: phone,
                message: data.message
            };

            if (tourType && tourId) {
                payload.tour_type = tourType;
                payload.tour_id = tourId;
                payload.date = startDate;
                payload.guests = data.guests;
                payload.total_price = tourPrice * data.guests;

                await axios.post('/api/booking', payload);
            } else {
                await axios.post('/api/callback', payload);
            }

            setPopup(true);
            setData({
                firstName:'',
                secondName:'',
                email:'',
                message:'',
                phone:'',
                date: null,
                guests: 1
            });
            setStartDate(null);
            setPhone('');
        } catch (err) {
            setError(t('callbackError'));
        } finally {
            setLoading(false);
        }
    }

    const handleClosePopup = () => {
        setPopup(false);
    };

    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <h3 style={{fontSize:'16px',color:'#1b7bbb'}}>{title}</h3>
                </AccordionSummary>
                <AccordionDetails>
                    <form onSubmit={handleSubmit}>
                        {popUp && <Snackbar
                            open={popUp}
                            autoHideDuration={6000}
                            onClose={handleClosePopup}
                            message={t('bookingSuccessMessage')}
                        />}
                        {error && <div className="alert alert-danger">{error}</div>}
                        <div className="row">
                            <div className="col-6">
                                <input
                                    type="text"
                                    className='form-control mb-3'
                                    placeholder={t('name')}
                                    value={data.firstName}
                                    onChange={(e) => handleInputChange('firstName', e.target.value)}
                                    required
                                />
                            </div>
                            <div className="col-6">
                                <input
                                    type="text"
                                    className='form-control mb-3'
                                    placeholder={t('surname')}
                                    value={data.secondName}
                                    onChange={(e) => handleInputChange('secondName', e.target.value)}
                                />
                            </div>
                        </div>
                        <input
                            type="email"
                            className='form-control mb-3'
                            placeholder={t('email')}
                            value={data.email}
                            onChange={(e) => handleInputChange('email', e.target.value)}
                            required
                        />
                        <PhoneInput
                            placeholder={t('phone')}
                            value={phone}
                            name='phone'
                            className='form-control mb-3'
                            onChange={setPhone}
                            required
                        />

                        {tourType && tourId && (
                            <div className="row">
                                <div className="col-6">
                                    <input
                                        type="number"
                                        className='form-control mb-3'
                                        placeholder={t('numberOfGuests')}
                                        value={data.guests}
                                        onChange={(e) => handleInputChange('guests', parseInt(e.target.value) || 1)}
                                        min="1"
                                        max="50"
                                        required
                                    />
                                </div>
                                <div className="col-6">
                                    {tourPrice && (
                                        <div className="form-control mb-3 d-flex align-items-center">
                                            {t('total')}: ${(tourPrice * data.guests).toFixed(2)}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        <textarea
                            className='form-control mb-3'
                            placeholder={t('willYouShare')}
                            value={data.message}
                            onChange={(e) => handleInputChange('message', e.target.value)}
                        ></textarea>

                        {tourType && tourId && (
                            <div className="d-flex mt-3 datePicker">
                                <DatePicker
                                    selected={startDate}
                                    onChange={handleDateChange}
                                    minDate={new Date()}
                                    locale={lang === 'de' ? de : undefined}
                                    filterDate={
                                        tourData && availableDateRanges.length > 0
                                            ? (d) => checkDateAvailability(d, tourData, availableDateRanges)
                                            : undefined
                                    }
                                    inline
                                    required
                                />
                            </div>
                        )}

                        <button
                            className='btn btn-primary mt-3 w-100'
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? t('sending') : t('send')}
                        </button>
                    </form>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default Callback;
